// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

export const ROOTS = {
  auth: "/auth",
  app: "/app",
  docs: "/docs",
  home: "/public",
};

export const PATH_PAGE = {
  root: "/",
  auth: {
    root: ROOTS.auth,
    login: path(ROOTS.auth, "/login"),
    loginUnprotected: path(ROOTS.auth, "/login-unprotected"),
    loginEmployee: path(ROOTS.auth, "/employee/:token"),
    // register: path(
    //   ROOTS.auth,
    //   process.env.NODE_ENV === 'development' ? '/register' : '/login'
    // ),
    // registerUnprotected: path(
    //   ROOTS.auth,
    //   process.env.NODE_ENV === 'development' ? '/register-unprotected' : 'login'
    // ),
    resetPassword: path(ROOTS.auth, "/reset-password"),
    verify: path(ROOTS.auth, "/verify"),
    // Bloque A onboarding v2: pantalla de introducción del OTP tras
    // registro público (30d trial sin CC). El registro real ocurre en
    // la landing; el Front solo verifica el código y arranca sesión.
    verifyOtp: path(ROOTS.auth, "/verify-otp"),
  },
  // Placeholder del wizard onboarding (Bloque B). Ruta activa desde
  // Bloque A para que VerifyOtpView tenga a dónde redirigir tras
  // verificar el OTP. Se rellena en los sprints B2..B6.
  wizard: "/wizard",
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  pricing: "/pricing",
  start: "/tucarta/:restaurante/:mesa/start",
  dynamicSession: "/tucarta/:restaurante/:mesa/:idSession/start",
  // URL pública de reservas online por restaurante. El slug viene del setting
  // `bookingPublicSlug` que el dueño configura en /settings.
  publicBooking: "/r/reservas/:slug",
  // URL pública de la carta (solo lectura, sin pedir). Reutiliza el MISMO
  // slug que las reservas (`bookingPublicSlug`) pero con su propio flag
  // `menuPublicEnabled`. Sin mesa ni sesión: solo consultar la carta.
  publicMenu: "/r/carta/:slug",
  // URL pública de "Gestionar mi reserva". Solo consulta — sin wizard. Los
  // correos/WhatsApp envían esta URL con ?code=NNN&email=… o &phone=… para
  // que el cliente vea su reserva sin teclear nada. Tiene un atajo arriba
  // a la derecha que devuelve al wizard si quiere hacer otra reserva.
  publicBookingManage: "/r/reservas/:slug/gestionar",
  // Auto-race waitlist (Resy-style): el cliente abre el link que recibió
  // en el email "tu hueco está disponible". Token Guid identifica la
  // oferta. TTL ~15 min: primero en confirmar gana.
  publicWaitlistOffer: "/r/waitlist-offer/:token",
  // Página pública sin auth para que el trabajador firme/rechace una
  // modificación de su fichaje. El token (256 bits hex) viaja en el email
  // que recibe; la API valida estado PENDING + no expirado y lo invalida
  // tras un único uso.
  signClocking: "/sign-clocking/:token",
  // Recordatorio de fichaje olvidado. El empleado recibe el enlace en el
  // email cuando el sistema detecta que su turno lleva abierto más allá de
  // la hora prevista. Sin auth — token Guid, TTL 2·IntervalMinutes.
  closeForgottenShift: "/cerrar-fichaje/:token",
  // Portal del trabajador: acceso temporal sin cuenta para consultar
  // fichajes, horario y firmas pendientes. Token con expiración configurable
  // por el admin (default 30 días). Multi-uso hasta que vence o se revoca.
  employeePortal: "/portal/:token",
  // F6: enlace público (sin auth) para que el cliente final genere su
  // propia factura nominativa tras escanear el QR del ticket. El :slug es
  // un GUID único single-use; tras canjear queda inutilizado.
  publicInvoice: "/factura/:slug",
};

export const PATH_HOME = {
  root: path(ROOTS.home, "/tucarta"),
  tucarta: {
    root: path(ROOTS.home, "/tucarta"),
    product: path(ROOTS.home, "/tucarta/product/:id"),
    checkout: path(ROOTS.home, "/tucarta/checkout"),
    checkoutResponse: path(ROOTS.home, "/tucarta/checkout/:status"),
    payment: path(ROOTS.home, "/tucarta/payment"),
    invoice: path(ROOTS.home, "/tucarta/invoice"),
    productoComplemento: path(ROOTS.home, "/tucarta/producto/:id"),
    successPayment: path(
      ROOTS.home,
      "/tucarta/payment/:status/:checkoutSessionId?",
    ),
  },
};

export const PATH_APP = {
  root: ROOTS.app,
  user: {
    root: path(ROOTS.app, "/user"),
    account: path(ROOTS.app, "/user/account"),
    subsSuccess: path(ROOTS.app, "/user/account/:responseCode"),
    subsCancel: path(ROOTS.app, "/user/account/:responseCode"),
    renewSubs: path(ROOTS.app, "/user/account/:responseCode"),
    subsCancelSuccess: path(ROOTS.app, "/user/account/:responseCode"),
    contact: path(ROOTS.app, "/user/contact/"),
    audit: path(ROOTS.app, "/user/audit"),
    tpvActivity: path(ROOTS.app, "/user/tpv-activity"),
    aeatErrors: path(ROOTS.app, "/user/aeat-errors"), // antigua: muestra la Auditoría
    aeatAudit: path(ROOTS.app, "/user/aeat-audit"),
    employeeCorrections: path(ROOTS.app, "/user/employee-corrections"),
    myPortal: path(ROOTS.app, "/user/my-portal"),
  },
  tuCarta: {
    root: path(ROOTS.app, "/tucarta"),
    sessions: path(ROOTS.app, "/tucarta/sessions"),
    product: path(ROOTS.app, "/tucarta/product/:id"),
    edit: path(ROOTS.app, "/tucarta/edit/:name"),
    tpv: path(ROOTS.app, "/tucarta/tpv"),
    mesas: path(ROOTS.app, "/tucarta/mesas"),
    reservas: path(ROOTS.app, "/tucarta/reservas"),
    // Add-on "Pedidos": pedidos desde carta QR (y futuras integraciones delivery).
    pedidos: path(ROOTS.app, "/tucarta/pedidos"),
    promociones: path(ROOTS.app, "/tucarta/promociones"),
    dashboard: path(ROOTS.app, "/tucarta/dashboard"),
    editTable: path(ROOTS.app, "/tucarta/mesas/edit/:id"),
    mesa: path(ROOTS.app, "/tucarta/tpv/mesa/:id"),
    printers: path(ROOTS.app, "/tucarta/printers"),
    addPrinter: path(ROOTS.app, "/tucarta/printers/add"),
    editPrinter: path(ROOTS.app, "/tucarta/printers/edit/:id"),
    // Fase 6: unificado como tabs bajo /printers?tab=...
    printerSystemStatus: path(ROOTS.app, "/tucarta/printers?tab=status"),
    printerDiscovery: path(ROOTS.app, "/tucarta/printers?tab=status"),
    // printerWorker se fusionó con el tab "status" en Fase 6.1; alias apunta ahí.
    printerWorker: path(ROOTS.app, "/tucarta/printers?tab=status"),
    printerInsights: path(ROOTS.app, "/tucarta/printers?tab=insights"),
    printerInstall: path(ROOTS.app, "/tucarta/printers?tab=install"),
    categories: path(ROOTS.app, "/tucarta/categories"),
    addCategory: path(ROOTS.app, "/tucarta/categories/add"),
    orderCategory: path(ROOTS.app, "/tucarta/categories/order"),
    editCategory: path(ROOTS.app, "/tucarta/categories/edit/:id"),
    caja: path(ROOTS.app, "/tucarta/caja"),
    discount: path(ROOTS.app, "/tucarta/discount"),
    editDiscount: path(ROOTS.app, "/tucarta/discount/edit/:id"),
    addDiscount: path(ROOTS.app, "/tucarta/discount/add"),
    productos: path(ROOTS.app, "/tucarta/productos"),
    productoComplemento: path(ROOTS.app, "/tucarta/producto/:id"),
    producto: path(ROOTS.app, "/tucarta/producto/:id/edit"),
    newProducto: path(ROOTS.app, "/tucarta/producto/new"),
    logs: path(ROOTS.app, "/tucarta/logs"),
    invoices: path(ROOTS.app, "/tucarta/invoices"),
    settings: path(ROOTS.app, "/tucarta/settings"),
    // Alias de compat — el contenido del antiguo "/installer" vive ahora en la
    // pestaña "Instalar" de /printers.
    installer: path(ROOTS.app, "/tucarta/printers?tab=install"),
    articles: path(ROOTS.app, "/tucarta/articles"),
    // Legacy — se mantiene la constante para redirects; el nav item se
    // reemplaza por `integrations` (bloque E onboarding v2). La ruta
    // ahora es un componente que redirige a /integrations/stripe/detail.
    stripe: path(ROOTS.app, "/tucarta/stripe"),
    integrations: path(ROOTS.app, "/tucarta/integrations"),
    integrationDetail: path(ROOTS.app, "/tucarta/integrations/:providerCode"),
    // Bloque C onboarding v2: panel histórico + settings de informes diarios.
    reportsDaily: path(ROOTS.app, "/tucarta/reports/daily"),
    // Bloque D onboarding v2 · Reseñas (add-on Reputación online).
    reviews: path(ROOTS.app, "/tucarta/reviews"),
    reviewDetail: path(ROOTS.app, "/tucarta/reviews/:id"),
    employees: path(ROOTS.app, "/tucarta/employees"),
    createEmployee: path(ROOTS.app, "/tucarta/employees/add"),
    editEmployee: path(ROOTS.app, "/tucarta/employees/edit/:id"),
    createEmployeeRole: path(ROOTS.app, "/tucarta/employees/roles/add"),
    editEmployeeRole: path(ROOTS.app, "/tucarta/employees/roles/edit/:id"),
    employeeCalendar: path(ROOTS.app, "/tucarta/employees/calendar"),
    employeeHolidays: path(ROOTS.app, "/tucarta/employees/festivos"),
    workSchedules: path(ROOTS.app, "/tucarta/employees/horarios"),
    rotationsV2: path(ROOTS.app, "/tucarta/employees/rotaciones"),
    factura: path(ROOTS.app, "/tucarta/factura"),
    facturaEdit: path(ROOTS.app, "/tucarta/factura/edit/:id"),
    facturaAdd: path(ROOTS.app, "/tucarta/factura/add"),
    estadisticas: path(ROOTS.app, "/tucarta/estadisticas"),
    estadisticasV2: path(ROOTS.app, "/tucarta/estadisticas-v2"),
    calendar: path(ROOTS.app, "/tucarta/calendar"),

    // paymentMethods
    paymentMethods: path(ROOTS.app, "/tucarta/payment-methods"),
    paymentMethodAdd: path(ROOTS.app, "/tucarta/payment-methods/add"),
    paymentMethodEdit: path(ROOTS.app, "/tucarta/payment-methods/edit/:id"),

    monitor: path(ROOTS.app, "/tucarta/monitor"),

    // displays
    displays: path(ROOTS.app, "/tucarta/displays"),
    displayAdd: path(ROOTS.app, "/tucarta/displays/add"),
    displayEdit: path(ROOTS.app, "/tucarta/displays/edit/:id"),

    tags: path(ROOTS.app, "/tucarta/tags"),
    addTag: path(ROOTS.app, "/tucarta/tags/add"),
    editTag: path(ROOTS.app, "/tucarta/tags/edit/:id"),
    orderTags: path(ROOTS.app, "/tucarta/tags/order"),

    // Inventario › Precios y promociones (pestañas Happy hour · Suplementos
    // por zona · Informe; `?tab=happy-hour|suplementos|informe`).
    precios: path(ROOTS.app, "/tucarta/precios"),
    // Rutas antiguas: redirigen a la pestaña de «Precios y promociones».
    priceRules: path(ROOTS.app, "/tucarta/promociones-horarias"),
    zoneCharges: path(ROOTS.app, "/tucarta/suplementos-zona"),

    // 2026-10 · «Inventario y costes» (hub: ?tab=inicio|articulos|recetas|compras|stock|rentabilidad&s=…).
    inventario: path(ROOTS.app, "/tucarta/inventario"),
    // Gestión (stock, costes, compras) — gestion y gestionOperaciones redirigen al hub.
    gestion: path(ROOTS.app, "/tucarta/gestion"),
    gestionOperaciones: path(ROOTS.app, "/tucarta/gestion/operaciones"),
    // Add/edit forms (need own route for URL params)
    gestionIngredienteAdd: path(ROOTS.app, "/tucarta/gestion/ingredientes/add"),
    gestionIngredienteEdit: path(ROOTS.app, "/tucarta/gestion/ingredientes/edit/:id"),
    gestionProveedorAdd: path(ROOTS.app, "/tucarta/gestion/proveedores/add"),
    gestionProveedorEdit: path(ROOTS.app, "/tucarta/gestion/proveedores/edit/:id"),
    gestionElaboracionAdd: path(ROOTS.app, "/tucarta/gestion/elaboraciones/add"),
    gestionElaboracionEdit: path(ROOTS.app, "/tucarta/gestion/elaboraciones/edit/:id"),
    gestionOrdenAdd: path(ROOTS.app, "/tucarta/gestion/compras/ordenes/add"),
    gestionAlbaranAdd: path(ROOTS.app, "/tucarta/gestion/compras/albaranes/add"),
    gestionRecetaEditor: path(ROOTS.app, "/tucarta/gestion/receta/:tipoOrigen/:idOrigen"),
    gestionEscandalloIA: path(ROOTS.app, "/tucarta/gestion/escandallo-ia"),
  },
  admin: {
    root: path(ROOTS.app, "/admin"),
    dashboard: path(ROOTS.app, "/admin/dashboard"),
    licences: path(ROOTS.app, "/admin/licences"),
    addLicence: path(ROOTS.app, "/admin/licences/add"),
    editLicence: path(ROOTS.app, "/admin/licences/edit/:id"),
    licenceBilling: path(ROOTS.app, "/admin/licences/billing/:id"),
    plans: path(ROOTS.app, "/admin/plans"),
    addPlan: path(ROOTS.app, "/admin/plans/add"),
    editPlan: path(ROOTS.app, "/admin/plans/edit/:id"),
    addOns: path(ROOTS.app, "/admin/addons"),
    distributors: path(ROOTS.app, "/admin/distributors"),
    addDistributor: path(ROOTS.app, "/admin/distributors/add"),
    editDistributor: path(ROOTS.app, "/admin/distributors/edit/:id"),
    notifications: path(ROOTS.app, "/admin/notifications"),
    addNotification: path(ROOTS.app, "/admin/notifications/add"),
    editNotification: path(ROOTS.app, "/admin/notifications/edit/:id"),
    invoices: path(ROOTS.app, "/admin/invoices"),
    addInvoice: path(ROOTS.app, "/admin/invoices/add"),
    editInvoice: path(ROOTS.app, "/admin/invoices/edit/:id"),
    observability: path(ROOTS.app, "/admin/observability"),
    // 2026-10-26 · Centro de control: sustituye a Live debug y Versiones
    // (las URL antiguas redirigen; ver AdminRoutes).
    control: path(ROOTS.app, "/admin/control"),
    controlRestaurant: path(ROOTS.app, "/admin/control/r/:rid"),
    liveDebug: path(ROOTS.app, "/admin/live-debug"),
    versions: path(ROOTS.app, "/admin/versions"),
    social: path(ROOTS.app, "/admin/social"),
  },
  tpv: {
    root: path(ROOTS.app, "/tpv"),
    cartaCamarero: path(ROOTS.app, "/tpv/camarero/carta"),
    pedidos: path(ROOTS.app, "/tpv/pedidos"),
    factura: path(ROOTS.app, "/tpv/factura"),
    facturaEdit: path(ROOTS.app, "/tpv/factura/edit/:id"),
    facturaAdd: path(ROOTS.app, "/tpv/factura/add"),
    productCamarero: path(ROOTS.app, "/tpv/camarero/product/:id"),
    checkoutCamarero: path(ROOTS.app, "/tpv/camarero/checkout"),
    productoComplemento: path(ROOTS.app, "/tpv/producto/:id"),
    paymentCamarero: path(ROOTS.app, "/tpv/camarero/payment"),
    invoiceCamarero: path(ROOTS.app, "/tpv/camarero/invoice"),
    pago: path(ROOTS.app, "/tpv/pago/:id"),
    tickets: path(ROOTS.app, "/tpv/tickets"),
    display: path(ROOTS.app, "/tpv/displays/:id"),
  },
  franquicia: {
    root: path(ROOTS.app, "/franquicia"),
    dashboard: path(ROOTS.app, "/franquicia/dashboard"),
    restaurantCharts: path(ROOTS.app, "/franquicia/dashboard/:id"),
    franquicias: path(ROOTS.app, "/franquicia/franquicias"),
    franquiciasEdit: path(ROOTS.app, "/franquicia/franquicias/:id"),
    franquiciasAdd: path(ROOTS.app, "/franquicia/franquicias/add"),
    categories: path(ROOTS.app, "/franquicia/categories"),
    addCategory: path(ROOTS.app, "/franquicia/categories/add"),
    editCategory: path(ROOTS.app, "/franquicia/categories/edit/:id"),
    caja: path(ROOTS.app, "/franquicia/caja"),
    productos: path(ROOTS.app, "/franquicia/productos"),
    producto: path(ROOTS.app, "/franquicia/producto/:id/edit"),
    newProducto: path(ROOTS.app, "/franquicia/producto/new"),
  },
  franquiciado: {
    root: path(ROOTS.app, "/franquiciado"),
    tpv: path(ROOTS.app, "/franquiciado/camarero-dark"),
    productos: path(ROOTS.app, "/franquiciado/productos"),
    productoComplemento: path(ROOTS.app, "/franquiciado/producto/:id"),
    producto: path(ROOTS.app, "/franquiciado/producto/:id/edit"),
    restaurantCharts: path(ROOTS.app, "/franquiciado/dashboard"),
    caja: path(ROOTS.app, "/franquiciado/caja"),
    pedidos: path(ROOTS.app, "/franquiciado/pedidos"),
    factura: path(ROOTS.app, "/franquiciado/factura"),
    facturaEdit: path(ROOTS.app, "/franquiciado/factura/edit/:id"),
    facturaAdd: path(ROOTS.app, "/franquiciado/factura/add"),
    mesa: path(ROOTS.app, "/franquiciado/tpv/mesa/:id"),
    printers: path(ROOTS.app, "/franquiciado/printers"),
    categories: path(ROOTS.app, "/franquiciado/categories"),
    addCategory: path(ROOTS.app, "/franquiciado/categories/add"),
    editCategory: path(ROOTS.app, "/franquiciado/categories/edit/:id"),
    employees: path(ROOTS.app, "/franquiciado/employees"),
    createEmployee: path(ROOTS.app, "/franquiciado/employees/add"),
    editEmployee: path(ROOTS.app, "/franquiciado/employees/edit/:id"),
    logs: path(ROOTS.app, "/franquiciado/logs"),
    cartaCamarero: path(ROOTS.app, "/franquiciado/camarero/carta"),
    productCamarero: path(ROOTS.app, "/franquiciado/camarero/product/:id"),
    checkoutCamarero: path(ROOTS.app, "/franquiciado/camarero/checkout"),
    paymentCamarero: path(ROOTS.app, "/franquiciado/camarero/payment"),
    invoiceCamarero: path(ROOTS.app, "/franquiciado/camarero/invoice"),
  },
};
